const Turl = "https://mapi.sonattrade.com/"
//const Turl = "http://194.99.21.74:3017"
//const Turl="https://mapi.bitbook.trade/bbk"
export { Turl }